import { LocationOutboundSMSNumber } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-numbers/phone_numbers.pb';
import {
  ListOutboundSMSNumbersRequest,
  ListOutboundSMSNumbersResponse,
} from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-numbers/phone_numbers_service.pb';
import { useQuery, UseQueryOptions } from 'react-query';
import { SchemaPhoneNumbersV1Service } from '../service';

export const useListOutboundSmsNumbers = (
  req: ListOutboundSMSNumbersRequest,
  options: UseQueryOptions<ListOutboundSMSNumbersResponse, unknown, LocationOutboundSMSNumber[] | undefined> = {}
) =>
  useQuery({
    queryKey: ['PhoneNumbersV1', 'ListOutboundSMSNumbers', req],
    queryFn: () => SchemaPhoneNumbersV1Service.ListOutboundSMSNumbers(req),
    select: (data) => data.locationOutboundSmsNumbers,
    ...options,
  });
